'use client';

import { Box, Button, Container, Typography, type SxProps } from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import clsx from 'clsx';
import React, { useState } from 'react';
import { PageBanner } from '../../components/PageBanner';
import { MyProjectDialog, type MyProjectDialogProps } from '../../dialogs/MyProjectDialog';
import { useRouterI18n } from '../../i18n/routing';
import { concatPaths } from '../../router';

const BANNER_TINT = '#92D050';
const BANNER_BACKGROUND = '#121212';

const BANNER_TABS = [
  { key: 'data-science', label: '데이터 과학' },
  { key: 'supervised', label: '지도학습' },
  { key: 'unsupervised', label: '비지도학습' },
  { key: 'generative', label: '생성모델' },
] as const;

type TabKey = (typeof BANNER_TABS)[number]['key'];

interface DialogParams {
  id: 'MyProjectDialog';
  props: MyProjectDialogProps;
}

interface Props {
  sx?: SxProps;
  className?: string;
  tab?: TabKey;
  title?: React.ReactNode;
  children?: React.ReactNode | ((tabKey: TabKey) => React.ReactNode);
}

export function AiLearnListLayout(props: Props) {
  const { sx, className, title, children } = props;
  const [dialogParams, setDialogParams] = useState<DialogParams | undefined>(undefined);
  const tabKey = BANNER_TABS.find((it) => it.key === props.tab)?.key ?? 'data-science';
  const router = useRouterI18n();

  const openDialogProps = () => {
    setDialogParams({
      id: 'MyProjectDialog',
      props: {
        open: true,
        onClose: () => {
          setDialogParams(undefined);
        },
      },
    });
  };
  return (
    <Box
      className={clsx('AiLearnListLayout-root', className)}
      sx={flatSx(
        {
          pb: 15,
        },
        sx,
      )}
    >
      <PageBanner
        title="AI학습"
        tint={BANNER_TINT}
        background={BANNER_BACKGROUND}
        contrastColor="#222"
        bgImgSrc="/_static/images/page-banner/top_banner2.png"
        tabKey={tabKey}
        tabs={BANNER_TABS}
        breadcrumbProps={{
          tint: '#fff',
          section: 'AI학습',
          currentTitle: BANNER_TABS.find((it) => it.key === tabKey)?.label ?? tabKey,
        }}
        onChangeTab={(_, value) => {
          router.push(concatPaths('ai-learn/list', value));
        }}
      />
      <Typography variant="h5" textAlign="center" sx={{ mt: '60px', mb: '30px' }}>
        {title}
      </Typography>
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          background: '#fff',
        }}
      >
        <Box
          className="AiLearnListLayout-myModelBtn"
          sx={{
            // position: 'absolute',
            // top: 0,
            // right: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            mb: 2,
            color: '#7ec72b',
          }}
        >
          <Button variant="outlined" color="primary" onClick={openDialogProps}>
            나의 모델
          </Button>
        </Box>
        {typeof children === 'function' ? children(tabKey) : children}
      </Container>
      {dialogParams?.id === 'MyProjectDialog' && <MyProjectDialog {...dialogParams.props} />}
    </Box>
  );
}
